import { Controller } from "@hotwired/stimulus"

import { localStorage } from "@/helpers/storage"

export default class extends Controller {
  static targets = ["loginSection", "logoutSection", "profileMenuButton", "userName"]

  declare readonly loginSectionTargets: HTMLElement[]
  declare readonly logoutSectionTarget: HTMLElement
  declare readonly profileMenuButtonTarget: HTMLButtonElement
  declare readonly userNameTarget: HTMLElement

  connect(): void {
    try {
      const { firstName } = JSON.parse(localStorage?.getItem("user") || "{}")

      if (firstName) {
        this.profileMenuButtonTarget.hidden = false
        this.profileMenuButtonTarget.textContent = firstName.charAt(0)
        this.userNameTarget.textContent = firstName
        this.loginSectionTargets.forEach((target) => (target.hidden = true))
        this.logoutSectionTarget.hidden = false
      }
    } catch (_) {
      // Ignore errors
    }
  }
}
